import { useEffect } from "react"

import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../util/analytics"
import { cohorts } from "../util/experiments"
import { localStorageItems } from "../util/storage"

export const useOnboardingCustomPlanExperiment = () => {
  useEffect(() => {
    const onboardingCustomPlanExperiment = localStorage.getItem(
      localStorageItems.onboardingCustomPlanExperiment
    )
    if (!!onboardingCustomPlanExperiment) return

    const randNum = Math.random()
    const variant = randNum < 0.5 ? cohorts.control : cohorts.variantA
    localStorage.setItem(
      localStorageItems.onboardingCustomPlanExperiment,
      variant
    )
    trackAnalyticEvent(ANALYTIC_EVENTS.EXPERIMENT_WEB_ONBOARDING_CUSTOM_PLAN, {
      cohort: variant,
    })
  }, [])
}
